/**
 * WooCommerce product & cart detection (platform layer)
 *
 * Everything in this file reads WooCommerce-rendered DOM: the .pmwProductId
 * markers printed for every product in a WooCommerce loop, the cart item
 * rows, WooCommerce's session/cart cookies, and the show_variation jQuery
 * event WooCommerce core triggers on variable products. Extracted from
 * pmw/functions.js in phase 4 of docs/PLATFORM-ABSTRACTION-PLAN.md; the
 * function bodies are unchanged.
 *
 * jQuery is fine here: this file only ever runs on WordPress.
 *
 * @since 1.65.0
 */

(function (pmw, $, undefined) {

	pmw.triggerViewItemList = productId => {

		if (!productId) throw Error("Wasn't able to retrieve a productId");

		productId = pmw.getIdBasedOndVariationsOutputSetting(productId);

		if (!productId) throw Error("Wasn't able to retrieve a productId");

		pmw.bus.emit("pmw:view-item-list", pmw.getProductDataForViewItemEvent(productId));
	};

	pmw.getMainProductIdFromProductPage = () => {

		try {
			if (["simple", "variable", "grouped", "composite", "bundle"].indexOf(pmwDataLayer.shop.product_type) >= 0) {
				return jQuery(".pmwProductId:first").data("id");
			} else {
				return false;
			}
		} catch (e) {
			console.error(e);
		}
	};

	/**
	 * Collect the product IDs of the products rendered in a product listing
	 *
	 * Reads the .pmwProductId markers that the Pixel Manager prints for every
	 * product of a WooCommerce loop, in DOM order, so the result mirrors the order
	 * the visitor sees. Duplicates are dropped, and only IDs that resolve in
	 * pmwDataLayer.products are returned, which keeps out markers whose product
	 * data never made it into the data layer.
	 *
	 * @since 1.64.1
	 *
	 * @returns {string[]} Product IDs in listing order
	 */
	pmw.getProductIdsFromListing = () => {

		try {
			return jQuery(".pmwProductId")
				.map((index, element) => String(jQuery(element).data("id")))
				.get()
				.filter((productId, index, productIds) =>
					productIds.indexOf(productId) === index && pmwDataLayer?.products?.[productId],
				);
		} catch (e) {
			console.error(e);
			return [];
		}
	};

	pmw.viewItemListTriggerTestMode = target => {

		jQuery(target).css({"position": "relative"});
		jQuery(target).append("<div id=\"viewItemListTriggerOverlay\"></div>");
		jQuery(target).find("#viewItemListTriggerOverlay").css({
			"z-index"         : "10",
			"display"         : "block",
			"position"        : "absolute",
			"height"          : "100%",
			"top"             : "0",
			"left"            : "0",
			"right"           : "0",
			"opacity"         : pmwDataLayer.shop.view_item_list_trigger.opacity,
			"background-color": pmwDataLayer.shop.view_item_list_trigger.background_color,
		});
	};

	// we need this to track timeouts for intersection observers
	let ioTimeouts = {};

	pmw.observerCallback = (entries, observer) => {

		entries.forEach((entry) => {

			try {
				let productId;

				let elementId = jQuery(entry.target).data("ioid");

				// Get the productId from next element, if wpmProductId is a sibling, like in Gutenberg blocks
				// otherwise go search in children, like in regular WC loop items
				if (jQuery(entry.target).next(".pmwProductId").length) {
					// console.log('test 1');
					productId = jQuery(entry.target).next(".pmwProductId").data("id");
				} else {
					productId = jQuery(entry.target).find(".pmwProductId").data("id");
				}


				if (!productId) throw Error("pmwProductId element not found");

				if (entry.isIntersecting) {

					ioTimeouts[elementId] = setTimeout(() => {

						pmw.triggerViewItemList(productId);
						if (pmwDataLayer.shop.view_item_list_trigger.test_mode) pmw.viewItemListTriggerTestMode(entry.target);
						if (pmwDataLayer.shop.view_item_list_trigger.repeat === false) observer.unobserve(entry.target);
					}, pmwDataLayer.shop.view_item_list_trigger.timeout);

				} else {

					clearTimeout(ioTimeouts[elementId]);
					if (pmwDataLayer.shop.view_item_list_trigger.test_mode) jQuery(entry.target).find("#viewItemListTriggerOverlay").remove();
				}
			} catch (e) {
				console.error(e);
			}
		});
	};

	// fire view_item_list only on products that have become visible
	let io;
	let ioid = 0;

	const getCommonIdentifiersToWatch = () => {

		let listOfClassNames = {
			nested: [],
			flat  : [],
		};

		try {

			const haveSameNestingDepth = (element1, element2) => {

				// If both are the same, return the parent
				return jQuery(element1).parents().length === jQuery(element2).parents().length;
			};

			const findCommonParentElement = (element1, element2) => {
				// If both are the same, return the parent
				if (jQuery(element1).parent().is(jQuery(element2).parent())) {
					return {
						node: jQuery(element1).parent(),
						type: "flat",
					};
				}

				return {
					node: jQuery(element1).parents().has(jQuery(element2).parents()).first(),
					type: "nested",
				};
			};

			const countOfChildren = (element) => {
				// Return the count of "wpmProductId" elements
				return jQuery(element).find(".pmwProductId").length;
			};

			const getCommonClass = (classes1, classes2) => {

				// console.log("classes1", classes1);
				// console.log("classes2", classes2);
				// classes 1 and 2 are arrays of classes
				// They may contain the same classes, but not in the same order
				// Return the first common class that's present in both arrays

				return classes1.filter(value => classes2.includes(value))[0] || null;
			};

			const pmwProductIds = document.querySelectorAll(".pmwProductId");

			// If zero or only one product template is found, then we can't run the algorithm
			if (pmwProductIds.length === 1) {
				// console.log("No product or too few templates found")
				return listOfClassNames;
			}

			// console.log("wpmProductIds", wpmProductIds);
			// console.log("looping")

			for (let i = 0; i < pmwProductIds.length - 1; i++) {

				// console.log("i", i)

				if (!haveSameNestingDepth(pmwProductIds[i], pmwProductIds[i + 1])) {
					// console.log("The nesting depth is not the same")
					i++;
					continue;
				}

				let productsNode = findCommonParentElement(pmwProductIds[i], pmwProductIds[i + 1]);
				// console.log("productsNode.node", productsNode.node)
				// console.log("productsNode.type", productsNode.type)

				// If the productsNode is nested, get the first class of the first child. Then console log the class
				if (productsNode.type === "nested") {

					let firstChildClassAttr = productsNode.node.children().first().attr("class");
					let firstChildClasses   = firstChildClassAttr ? firstChildClassAttr.split(" ") : [];

					let secondChildClassAttr = productsNode.node.children().first().next().attr("class");
					let secondChildClasses   = secondChildClassAttr ? secondChildClassAttr.split(" ") : [];

					const commonClass = getCommonClass(firstChildClasses, secondChildClasses);

					listOfClassNames.nested.push(commonClass);
				} else if (productsNode.type === "flat") {

					// If class is not found, continue
					if (!productsNode.node.children().first().attr("class")) continue;

					// firstProductTemplateClasses is the classes of the first child element of the productsNode
					let firstProductTemplateClasses = productsNode.node.children().first().attr("class").split(" ")[0];

					listOfClassNames.flat.push(firstProductTemplateClasses);
				}

				// which wpmProductIds is the last one in the productsNode? console log the index of the last wpmProductId in the productsNode
				// console.log("productsNode.children().length", countOfChildren(productsNode));

				i = i + countOfChildren(productsNode.node) - 1;
			}

			// Make the list of class names unique
			listOfClassNames.nested = [...new Set(listOfClassNames.nested)];
			listOfClassNames.flat   = [...new Set(listOfClassNames.flat)];

			return listOfClassNames;

		} catch (e) {
			console.error(e);
			return listOfClassNames;
		}
	};


	let detectedProductTemplateClasses = {
		nested: [],
		flat  : [],
	};

	const isNestedClass = (elem) => {
		let nestedClassNames = [
			"product",
			"type-product",
			"product-item-inner",
			...detectedProductTemplateClasses.nested,
		];

		return nestedClassNames.some(className => jQuery(elem).closest("." + className).length);
	};

	const isFlatClass = (elem) => {

		let flatClassNames = [
			"wc-block-grid__product",
			"product",
			"product-small",
			"woocommerce-LoopProduct-link",
			...detectedProductTemplateClasses.flat,
		];

		return flatClassNames.some(className => jQuery(elem).prev().hasClass(className));
	};

	const getAllElementsToWatch = () => {

		detectedProductTemplateClasses = getCommonIdentifiersToWatch();

		return jQuery(".pmwProductId")
			.map(function (i, elem) {

				if (isNestedClass(elem)) {
					return jQuery(elem).parent();
				} else if (isFlatClass(elem)) {
					return jQuery(this).prev();
				} else if (jQuery(elem).closest(".product").length) {
					return jQuery(elem).closest(".product");
				}
			});
	};

	/**
	 * Hand every product element that is not watched yet to the intersection
	 * observer.
	 *
	 * Idempotent, because it runs again after every client-side re-render:
	 * blocks that run on the Interactivity API replace whole regions of the
	 * page on pagination and filtering, and the elements that survive such a
	 * pass must not be observed a second time.
	 */
	const observeProductElements = () => {

		if (!io) return;

		getAllElementsToWatch().each((i, elem) => {

			const node = elem[0] ? elem[0] : elem;

			if (!node) return;
			if (jQuery(node).data("pmwObserved")) return;

			jQuery(node).data("pmwObserved", true);
			jQuery(node).data("ioid", ioid++);

			io.observe(node);
		});
	};

	pmw.startIntersectionObserverToWatch = () => {

		try {
			// enable view_item_list test mode from browser
			if (pmw.urlHasParameter("vildemomode")) pmwDataLayer.shop.view_item_list_trigger.test_mode = true;

			// set up intersection observer
			// https://stackoverflow.com/questions/62084306/intersectionobserver-not-working-in-safari-or-ios
			io = new IntersectionObserver(pmw.observerCallback, {
				root: null,
				// root     : document.body,
				threshold: pmwDataLayer.shop.view_item_list_trigger.threshold,
			});

			observeProductElements();
		} catch (e) {
			console.error(e);
		}
	};

	/**
	 * Pick up products that appeared after the initial observer run, whether
	 * they were lazy loaded, added by a page builder, or rendered by a block
	 * running on the Interactivity API.
	 *
	 * Called from the DOM refresh pipeline in interactivity-dom.js.
	 */
	pmw.observeNewProductElements = () => {

		try {
			observeProductElements();
		} catch (e) {
			console.error(e);
		}
	};

	// Watch DOM for new lazy loaded products and add them to the intersection observer
	pmw.startProductsMutationObserverToWatch = () => {

		try {
			// Pass in the target node, as well as the observer options

			// selects the most common parent node
			// https://stackoverflow.com/a/7648323/4688612
			let productsNode = jQuery(".pmwProductId:eq(0)").parents().has(jQuery(".pmwProductId:eq(1)").parents()).first();

			if (productsNode.length) {
				productsMutationObserver.observe(productsNode[0], {
					attributes   : true,
					childList    : true,
					characterData: true,
				});
			}
		} catch (e) {
			console.error(e);
		}
	};

	// Create an observer instance
	const productsMutationObserver = new MutationObserver(mutations => {

		mutations.forEach(mutation => {
			let newNodes = mutation.addedNodes; // DOM NodeList
			if (newNodes !== null) { // If there are new nodes added
				let nodes = jQuery(newNodes); // jQuery set
				nodes.each((i, node) => {
					if (
						// jQuery(this).hasClass("type-product") ||
						// jQuery(this).hasClass("product-small") ||
						// jQuery(this).hasClass("wc-block-grid__product")
						// jQuery(this).hasClass("type-product")
						isNestedClass(node) || isFlatClass(node)
					) {
						// check if the node has a child or sibling wpmProductId
						// if yes add it to the intersectionObserver
						if (hasPmwProductIdElement(node) && !jQuery(node).data("pmwObserved")) {
							jQuery(node).data("pmwObserved", true);
							jQuery(node).data("ioid", ioid++);
							io.observe(node);
						}
					}
				});
			}
		});
	});

	let hasPmwProductIdElement = elem =>
		!!(jQuery(elem).find(".pmwProductId").length ||
			jQuery(elem).siblings(".pmwProductId").length);

	pmw.getProductIdByCartItemElement = element => {

		const href = jQuery(element).find(".product-remove").find("a").attr("href");
		if (href) return pmw.getProductIdByCartItemKeyUrl(new URL(href));

		const productId = jQuery(element).find("[data-product_id]").first().attr("data-product_id");
		return productId ? productId : null;
	};

	pmw.getProductQuantityByCartItemElement = element => {

		return jQuery(element).find(".qty").val() || null;
	};

	pmw.getProductIdByCartItemKeyUrl = url => {

		let searchParams = new URLSearchParams(url.search);
		let cartItemKey  = searchParams.get("remove_item");

		let productId;

		if (pmwDataLayer.cart_item_keys[cartItemKey]["variation_id"] === 0) {
			productId = pmwDataLayer.cart_item_keys[cartItemKey]["product_id"];
		} else {
			productId = pmwDataLayer.cart_item_keys[cartItemKey]["variation_id"];
		}

		return productId;
	};

	pmw.getAddToCartLinkProductIds = () =>
		jQuery("a").map(function () {
			let href = jQuery(this).attr("href");

			if (href && href.includes("?add-to-cart=")) {
				let matches = href.match(/(add-to-cart=)(\d+)/);
				if (matches) return matches[2];
			}
		}).get();

	pmw.doesWooCommerceCartExist = () => document.cookie.includes("woocommerce_items_in_cart");

	pmw.isWooCommerceActive = () => {
		return !!pmwDataLayer.shop;
	};

	pmw.isInWooCommerceSesssion = () => {

		if (pmwDataLayer?.shop?.session_active) return true;

		let regex           = new RegExp("woocommerce_cart_hash");
		let wcSessionCookie = pmw.getCookieThatContainsRegex(regex);

		if (wcSessionCookie) return true;

		return false;
	};

	pmw.isNotInWooCommerceSesssion = () => {
		return !pmw.isInWooCommerceSesssion();
	};

	pmw.registerShowVariationEventListener = () => {
		let previousVariationId = null;

		jQuery(".single_variation_wrap").on("show_variation", (event, variation) => {

			// Abort if lazy loading is enabled
			// if (pmwDataLayer?.general?.lazy_load_pmw) return;

			try {
				// If variations_output is disabled, don't fire view_item events from show_variation
				// because the parent product view_item is already triggered on page load
				if (!pmwDataLayer?.shop?.variations_output) return;

				let productId = pmw.getIdBasedOndVariationsOutputSetting(variation.variation_id);

				if (!productId) throw Error("Wasn't able to retrieve a productId");

				// If the variation id is not the same as the previous one, run the function
				if (previousVariationId !== variation.variation_id) {
					pmw.triggerViewItemEventPrep(productId);
					previousVariationId = variation.variation_id;
				}

			} catch (e) {
				console.error(e);
			}
		});
	};

}(window.pmw = window.pmw || {}, jQuery));
